CustomTC.define('modules/extension/extension',['modules/config', 'modules/core'], function(config, core) {
    return {
        // initialize
        init: function(type, extConfig) {
            var self = this;
            var url = '';
            if (extConfig && typeof(extConfig.url) !== 'undefined')
                url = extConfig.url;
            else if (config.extensions[type]) {
                url = config.extensions[type].url;
            }
            if (url) {
                // add the extension js to head
                var head = document.getElementsByTagName('head')[0],
                    script = document.createElement('script');
                script.async = true;
                script.src = url;
                head.appendChild(script);
            }
            var extClassName = type.substr(0, 1).toUpperCase() + type.substr(1) + 'Extension';
            if (window[extClassName]) {
                return self.returnObject(extClassName, extConfig.other_config);
            }
            else {
                var extEvent = null;
                if (typeof TouchCast.Extensions !== 'undefined') {
                    extEvent = 'TouchCast.Extensions.' + type.toUpperCase() + '_EXTENSION_INITIALIZED';
                    extEvent = eval(extEvent);
                }
                else
                    extEvent = type.toUpperCase() + '_EXTENSION_INITIALIZED';
                if (extEvent) {
                    core.on(core.init(document), extEvent, function() {
                        self.returnObject(extClassName, extConfig.other_config);
                    });
                }
            }
        },
        // return extension
        returnObject: function(name, other_config) {
            if (typeof window[name] !== 'undefined')
                return new window[name](other_config);
        }
    }
});
